// A gate that forwards each failure condition only the first time it is seen, with no Angular in
// it so it can be tested. Used where the same failure can recur many times in one page load (a
// storage read on every navigation, a teardown on every reconnect) and one report is enough
// (#5191).

/** Hands a failure on under a stable condition name. */
export type ConditionReporter = (conditionName: string, err: unknown) => void;

/**
 * Wraps `report` so each condition name is forwarded only the first time. Keep one per page
 * load, so a device whose storage is blocked files one event rather than one per screen.
 */
export function createOncePerConditionReporter(report: ConditionReporter): ConditionReporter {
  const reported = new Set<string>();
  return (conditionName, err) => {
    if (reported.has(conditionName)) return;
    reported.add(conditionName);
    report(conditionName, err);
  };
}
